import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from "react";
import { __ } from "@jti/fe-common";
import { PageTitle } from "@jti/ui";
import ResetEmailSent from "./ResetEmailSent";
import ResetPasswordForm from "./ResetPasswordForm";
import styles from "./ResetPassword.module.scss";
const ResetPassword = () => {
    const [resetEmailSent, setResetSuccessful] = useState(false);
    const handleResetPassword = useCallback(() => {
        setResetSuccessful(true);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { className: styles.title, title: __("auth.forgot_password.page_title.title"), text: __("auth.forgot_password.page_title.sub_title") }), _jsx("div", { className: styles.container, children: resetEmailSent ? _jsx(ResetEmailSent, {}) : _jsx(ResetPasswordForm, { onSuccessfulReset: handleResetPassword }) })] }));
};
export default memo(ResetPassword);
